// extracted by mini-css-extract-plugin
module.exports = {"exitPollWidgetWrapper":"zC9Z2","noteText":"WpAZ0","source":"xNpuL"};